// The lowest loaded sample is B0. Higher notes use the existing transposition
// path, bounded by the MIDI note range rather than accepting arbitrary numbers.
export const MIN_AUDIO_PITCH = 23;
export const MAX_AUDIO_PITCH = 127;

export const isSupportedAudioPitch = pitch => Number.isInteger(pitch) &&
  pitch >= MIN_AUDIO_PITCH && pitch <= MAX_AUDIO_PITCH;
